import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4014E87F-B3F7-465B-B84D-ED2408AA95EE
 * name dock-top
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dock-top.svg
 * tags
 */
export const DockTopIcon = createSvgIcon(<><path d="M4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20M4 11H20V18H4V11Z" /></>, 'DockTopIcon');
export default DockTopIcon